import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface LayoutV2State {
  isExpandedMenu: boolean
  isEnableFixedMenu: boolean
  setIsExpandedMenu: (isExpandedMenu: boolean) => void
  setIsEnableFixedMenu: (isEnableFixedMenu: boolean) => void
  reset: () => void
}

const initialState = {
  isExpandedMenu: true,
  isEnableFixedMenu: false
}

export const useLayoutV2Store = create<LayoutV2State>()(
  persist(
    (set, get) => ({
      ...initialState,
      setIsExpandedMenu: (isExpandedMenu) =>
        set(() => {
          if (get()?.isEnableFixedMenu) {
            return { isExpandedMenu: true }
          }
          return { isExpandedMenu }
        }),
      setIsEnableFixedMenu: (isEnableFixedMenu) => set({ isEnableFixedMenu }),
      reset: () => set({ ...initialState })
    }),
    {
      name: 'layout-storage'
    }
  )
)
